import {
    type GetUploadTokenForFormPhotoWithoutAuthRequestType,
    type GetUploadTokenForFormPhotoWithoutAuthResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetUploadTokenForFormPhotoWithoutAuth = async (params: GetUploadTokenForFormPhotoWithoutAuthRequestType): Promise<GetUploadTokenForFormPhotoWithoutAuthResponseType> => {
    return await axios(`${SERVER_ADDRESS}/event/getUploadTokenForFormPhotoWithoutAuth`, {
        method: "POST",
        headers: getHeaders(false),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetUploadTokenForFormPhotoWithoutAuth;
